import { EMAIL_SERVICES, DEFAULT_PROVIDER } from "../constants/Constants";

export const decodeHtml = html => {
  let txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};
export const getResolvedProvider = (
  providerState,
  emailService,
  campaign = null
) => {
  if (providerState === DEFAULT_PROVIDER) {
    return campaign?.email_service || emailService;
  }
  return providerState;
};

export const getProviderChecks = provider => {
  return {
    provider,
    isSMTP: provider === EMAIL_SERVICES.SMTP,
    isOutlook: provider === EMAIL_SERVICES.OUTLOOK,
    isMailgun: provider === EMAIL_SERVICES.MAILGUN,
  };
};

export const shouldShowCampaignDefault = (
  onlySmtp,
  emailService,
  campaign = null
) => {
  if (onlySmtp) return false;
  if (emailService === EMAIL_SERVICES.CONSTANT_CONTACT) return false;
  if (campaign?.email_service === EMAIL_SERVICES.CONSTANT_CONTACT) return false;
  return true;
};

export const isTemplateDisabled = (template, provider) => {
  if (!provider) return false;
  const { provider_list: providerList } = template.info || {};
  if (!providerList) return false;

  let disabled;
  switch (provider) {
    case EMAIL_SERVICES.MAILGUN:
    case EMAIL_SERVICES.SENDGRID:
      disabled = !providerList.mailgun_sendgrid;
      break;
    case EMAIL_SERVICES.CONSTANT_CONTACT:
      disabled = !providerList.constant_contact;
      break;
    case EMAIL_SERVICES.SMTP:
      disabled = !providerList.smtp;
      break;
    default:
      disabled = false;
  }
  return disabled;
};

export const createTemplateOptions = (
  templates,
  campaignTemplates,
  templateDisabledFn
) => {
  if (!templates || templates.length === 0) {
    return [];
  }

  let templateOptions = templates.map(template => {
    let disabled = templateDisabledFn ? templateDisabledFn(template) : false;
    let description = disabled ? "Disabled for selected provider" : null;

    if (!template.enabled) {
      disabled = true;
      description = "Empty template";
    }
    return {
      ...template,
      key: template.id,
      value: template.id,
      text: template.name || template.text,
      description,
      disabled,
    };
  });
  if (campaignTemplates && campaignTemplates.length > 0) {
    templateOptions = templateOptions.filter(template => {
      return (
        campaignTemplates.includes(template.id) ||
        campaignTemplates.includes(template.value)
      );
    });
  }
  return templateOptions;
};
